import React from 'react';
import {useTheme} from '@mui/material/styles';
import {Box, ButtonBase, Grid, Link, Slide, useMediaQuery} from "@mui/material";
import {RomaTreIcon} from "../Icons/RomaTreIcon";


type FooterProps = {
  title?: string,
  children?: React.ReactNode,
  style?: React.CSSProperties,
  disableChildren?: boolean,
  animate?: boolean
}

const Footer: React.FC<FooterProps> = ({title, children, style, disableChildren, animate}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("xl"))

  return (
    <Slide direction="up" in appear={animate} timeout={500}>
      <Box
        sx={{
          ...style,
          position: 'fixed',
          width: '100%',
          right: 0,
          bottom: 0,
          pt: 2,
          zIndex: theme => theme.zIndex.appBar,
        }}>
        {!disableChildren && children}
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          py={isLargeScreen ? 2 : 1}
          px={isLargeScreen ? 4 : 3}
          sx={{
            borderTop: 'solid 1px',
            bgcolor: theme => theme.palette.background.default,
          }}
        >
          <Grid item xs={6} container justifyContent="flex-start" alignItems="center" spacing={isMobile ? 1 : 4}>
            <Grid item>
              <Link fontSize="small" href="/terms" color="inherit" underline="hover">Privacy & Terms</Link>
            </Grid>
            <Grid item>
              <Link fontSize="small" href="/contacts" color="inherit" underline="hover">Contacts</Link>
            </Grid>
          </Grid>
          <Grid item xs={6} container justifyContent="flex-end" alignItems="center" spacing={4}>
            {useMediaQuery(theme.breakpoints.up("lg")) && <Grid item alignItems="center">
                <Link fontSize="small" href="/about" color="inherit" underline="hover"> A project from AI research lab -
                    Roma
                    Tre university</Link>
            </Grid>}
            <Grid item alignItems="center">
              <Box pt={1}>
                <ButtonBase onClick={() => window.open('https://www.uniroma3.it/')}>
                  <RomaTreIcon fill={theme.palette.text.primary} height={isMobile ? 30 : 50}/>
                </ButtonBase>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};


export default Footer;